import "./JoinUs.css";

function JoinUs() {
    return (
        <div>
            <div className="joinus-grid">
                <div className="grid-text">
                    <div className="publication-header" style={{ fontSize: "50px" }}>
                        Join Us
                    </div>
                </div>
                <div />
            </div>
            <div className="joinus-profile-section">
                <div className="top-profile"></div>

                <div className="joinus-tabs-row">
                    <div className="joinus-tab">
                        <u><h3 style={{justifySelf:"center"}}>Undergraduate Students</h3></u><br></br>
                        <p style={{ textAlign: "justify", fontSize: "22px" }}>
                            Current NTU undergrads can either email <a href="mailto:anuvab.das@ntu.edu.sg" target="_blank"
                                rel="noopener noreferrer">Anuvab</a> or drop by office CCEB-06-21. For email inquiries, please use the subject line <strong>“Application for Undergraduate Research”</strong>. If you are interested in gaining hands-on experience in synthetic chemistry and molecular biology, come join us!
                        </p>
                    </div>

                    <div className="joinus-tab">
                        <u><h3 style={{justifySelf:"center"}}>Graduate Students</h3></u><br></br>
                        <p style={{ textAlign: "justify", fontSize: "22px" }}>
                           We are currently seeking highly motivated Ph.D. and Master’s students. Prospective students interested in joining our research group are encouraged to contact <a href="mailto:anuvab.das@ntu.edu.sg" target="_blank"
                                rel="noopener noreferrer">Anuvab</a> directly. For email inquiries, please use the subject line <strong>“Application for PhD Position”</strong> or <strong>“Application for Master’s Research”</strong>. Please ensure that you meet the admission requirements for the Chemistry graduate program at NTU before applying.
                        </p>
                    </div>

                    <div className="joinus-tab">
                        <u><h3 style={{justifySelf:"center"}}>Postdoctoral Scholars</h3></u><br></br>
                        <p style={{ textAlign: "justify", fontSize: "22px" }}>
                            Interested postdoc candidates should email <a href="mailto:anuvab.das@ntu.edu.sg" target="_blank"
                                rel="noopener noreferrer">Anuvab</a> directly with a cover letter, CV, and a brief research summary. Please use the subject line <strong>“Application for Postdoctoral Position”</strong>.
                        </p>
                    </div>
                </div>
            </div>

        </div>

    );
}

export default JoinUs;